import { Instance } from 'mobx-state-tree'
import { RecursiveRemoveUndefined } from '../../utils'
import { PlayerStatBestHandWonModelBase } from './PlayerStatBestHandWonModel.base'

/* The TypeScript type of an instance of PlayerStatBestHandWonModel */
export interface PlayerStatBestHandWonModelType
  extends RecursiveRemoveUndefined<Instance<typeof PlayerStatBestHandWonModel>> {}

/* A graphql query fragment builders for PlayerStatBestHandWonModel */
export {
  selectFromPlayerStatBestHandWon,
  playerStatBestHandWonModelPrimitives,
  PlayerStatBestHandWonModelSelector
} from './PlayerStatBestHandWonModel.base'

/**
 * PlayerStatBestHandWonModel
 */
export const PlayerStatBestHandWonModel = PlayerStatBestHandWonModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
